import { type RecordId } from 'javascripts/shared-types';
import ListDropHandler from 'javascripts/dnd/ListDropHandler';
import type CardLayoutEditorController from '../controllers/CardLayoutEditorController';

class CardFieldDropHandler extends ListDropHandler<CardLayoutEditorController> {
  groupId: RecordId;

  constructor(params) {
    super(params);

    this.groupId = params.groupId;
  }

  static get accepts() {
    return ['DraggableCardField', 'DraggableFieldPreview'];
  }

  async onDropAtDropPlacement({ dragItems, placement }) {
    const { groupId } = this;
    const { cardField, field } = dragItems[0];

    this.controller.actionDropFieldInCardGroup({
      groupId,
      field,
      cardField,
      placement,
    });
  }

  onRemoveItems({ dragItems }) {
    const { cardField } = dragItems[0];

    this.controller.actionRemoveCardField({ cardField });
  }
}

export default CardFieldDropHandler;
